import { render, staticRenderFns } from "./HazmatErrorNotification.vue?vue&type=template&id=0f3e889a&scoped=true"
import script from "./HazmatErrorNotification.vue?vue&type=script&lang=js"
export * from "./HazmatErrorNotification.vue?vue&type=script&lang=js"
import style0 from "./HazmatErrorNotification.vue?vue&type=style&index=0&id=0f3e889a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f3e889a",
  null
  
)

export default component.exports